import { inject, Injectable } from '@angular/core';
import { Method } from 'eurogard-pattern';
import {
  UserControllerUpdateUserLanguageRemoteMethod,
} from 'open-api-legacy/remote-methods/user-controller-update-user-language.remote-method';
import {
  UserControllerUpdateUserLanguageResponse
} from 'open-api-legacy/responses/user-controller-update-user-language.response';

@Injectable({providedIn: 'root'})
export class SetUserLanguageInCloudServerMethod implements Method<any, string> {

  private setLanguage = inject(UserControllerUpdateUserLanguageRemoteMethod);

  async call(language: string): Promise<UserControllerUpdateUserLanguageResponse> {
    language = language.replace(/-.+$/, '').toLowerCase();
    let code: string;
    switch (language) {

      case 'de':
        code = '0';
        break;

      case 'en':
        code = '1';
        break;

      case 'fr':
        code = '2';
        break;

      case 'it':
        code = '3';
        break;

      default:
        throw new Error(`The language '${ language } is not supported'`);

    }

    return this.setLanguage.call({
      requestBody: {
        updateMap: {
          userLanguage: code,
        },
      },
    });
  }

}
